// extracted by mini-css-extract-plugin
export default {"dialogContent":"style--dialogContent--30efbc","tabContent":"style--tabContent--9f9a5d","container":"style--container--7fe570"};